import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-reset-accesslist>
  <paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname} edit={opts.edit} selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol}
    submitfunc={submitHandler}>
  
    <yield to="fields">

      <div if={parent.loading} class="d-flex justify-content-center pt-5 pb-5">
        <p class="my-auto">Firewall-Einstellungen werden aktualisiert...</p>
        <div class="sk-wave">
          <div class="sk-rect sk-rect1"></div>
          <div class="sk-rect sk-rect2"></div>
          <div class="sk-rect sk-rect3"></div>
          <div class="sk-rect sk-rect4"></div>
          <div class="sk-rect sk-rect5"></div>
        </div>
      </div>

    <div class="paedml-input-group" show={!parent.loading}>
        <div class="pb-1">
          Klassen-Whitelist auf den Standardwert zurücksetzen:
        </div>
        <div class="row">
          <div class="col-sm-12">
            <label>Standard-Whitelist</label>
            <textarea class="form-control" maxlength=4097 data-rule-maxlength=4096 data-msg-maxlength="Es sind bis zu 4096 Zeichen erlaubt" name="whitelist" 
              cols="28" rows="10" readonly>
            </textarea>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
             <paedml-form-input name="whitelistActive" placeholder="Whitelist aktiv" fgclass="py-1"
                type="checkbox" revlut="jaNein" readonly
              />
          </div>
          <div class="col-sm-6">
            <paedml-form-input name="whitelistOnly" placeholder="Nur Whitelist verwenden" fgclass="py-1"
                type="checkbox" revlut="jaNein" readonly
            />
          </div>
        </div>
    </div>

    </yield>
  </paedml-modal>
    
  <script>
    import store from '../../store'
    import * as mapper from '../../mapper'
    import * as R from 'ramda'
    import Session from '../../store/session'
    import API from '../../api'
    import moment from 'moment'

    this.opname = this.opts.opname
    this.edit = this.opts.edit ? true : false
    this.data = {}
    this.session = Session

    this.load = (id) => {
      this.loading = true
      return API.fwklassen.defaultWhitelist(id).then(rsp => {
        
        const [fw, status] = rsp
        
        this.data.whitelist = R.join('\n', fw.whitelist)

        this.update()
        return rsp
      })
    }

    this.on('update', () => {
      this.loading = false
    })

    this.on('rowMappingRequested', (cols, modal) => {
      this.data.id = cols[0] || 0

      this.load(this.data.id).then(rsp => {
        const [fw, status] = rsp
        fw.whitelist = R.join('\n', fw.whitelist)
        this.data = fw
        
        modal.trigger('refreshData')
      })

    })

    this.submitHandler = formData => {
      
      return API.fwklassen.resetWhitelist(this.data.id).then(rsp => {
        const [result, status] = rsp
        if(status.success) {
          this.parent.trigger('reloadTable')
          return 'Änderungen erfolgeich übernommen.'
        }
        else {
          if(data.message){
            return Promise.reject(data.message)
          }
          return Promise.reject('Änderungen konnten nicht übernommen werden.')
        }
      })
    }

  </script>
</paedml-modal-reset-accesslist>
